//
// Image Slider
// --------------------------------------------------
// Building on top of native browser features like
// CSS Scroll Snap, CSS Smooth Scrolling
// --------------------------------------------------
// Code forked & modified from
// https://web.dev/building-a-stories-component/
// --------------------------------------------------
// TODO
// - add interaction observer for slide user has scrolled to (https://stackoverflow.com/a/67236837/4486857), update state
//   - then, link current slide to dots via an observer
// - pause autoplay on hover? ( https://stackoverflow.com/a/29902917/4486857 )
// - cancel autoplay on L/R key press?
// - clean up
// --------------------------------------------------

import debounce from './helpers/debounce.js';

let imageSliderAutoplayInterval;

const imageSliderWrapper = document.querySelector('.image-slider-wrapper');
const imageSlider = document.querySelector('.image-slider');
const imageSliderSlides = document.querySelectorAll('.image-slider .slide');
// const median =
//   imageSliderWrapper.offsetLeft + imageSliderWrapper.clientWidth / 2;
const firstSlide = imageSlider.firstElementChild;
const lastSlide = imageSlider.lastElementChild;

const jumpDots = document.querySelectorAll('.jump-dot');

let userScrolled = false;

const state = {
  current_slide: firstSlide,
};

function navigateImageSlider(direction) {
  const slide = state.current_slide;
  let scrollBehavior = 'smooth';

  if (direction === 'next') {
    // return / ignore if on the last slide
    if (lastSlide === slide) {
      // console.log('on last slide...now to loop back');
      // scrollBehavior = 'auto';
      state.current_slide = firstSlide;
      // return;
    }
    //
    else {
      // slide.classList.add('seen');
      state.current_slide = slide.nextElementSibling;
    }
  } else if (direction === 'prev') {
    // return / ignore if on the first slide
    if (firstSlide === slide) {
      // console.log('on first slide...now to loop back to end');
      // scrollBehavior = 'auto';
      state.current_slide = lastSlide;
      // return;
    }
    //
    else {
      // slide.nextElementSibling.classList.remove('seen');
      state.current_slide = slide.previousElementSibling;
    }
  }

  state.current_slide.scrollIntoView({
    behavior: scrollBehavior,
    inline: 'center',
    block: 'nearest',
  });
}

function handleLeftOrRightSideClick(event) {
  if (!event.target.closest('.image-slider')) return;

  console.info(
    'user initiated a scroll via left or right side click. autoplay will be cancelled.'
  );
  userScrolled = true;

  navigateImageSlider(
    event.clientX >
      imageSliderWrapper.offsetLeft + imageSliderWrapper.clientWidth / 2
      ? 'next'
      : 'prev'
  );
}

// click on left side goes back; click on right side goes forward
imageSliderWrapper.addEventListener('click', handleLeftOrRightSideClick);

function handleJumpDotNavigation(event) {
  event.preventDefault();

  console.info(
    'user initiated a scroll via clicking a jump dot. autoplay will be cancelled.'
  );
  userScrolled = true;

  const target = event.target.closest('.jump-dot');

  const slideNumberGoingTo = Number(target.dataset.goToSlide);
  const slideGoingTo = document.querySelector(
    `[data-slide="${slideNumberGoingTo}"]`
  );
  // console.log(slideNumberGoingTo);
  // console.log(slideGoingTo);

  state.current_slide = slideGoingTo;
  // console.log('state.current_slide: ', state.current_slide);

  state.current_slide.scrollIntoView({
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest',
  });
}
jumpDots.forEach((jumpDot) => {
  jumpDot.addEventListener('click', handleJumpDotNavigation);
});

// handle up and down arrow keys
// (left & right arrows are free with snap points)
// document.addEventListener('keydown', ({ key }) => {
//   console.log('key: ', key);
//   console.log(`key !== 'ArrowDown'`, key !== 'ArrowDown');
//   console.log(`key !== 'ArrowUp'`, key !== 'ArrowUp');

//   if (key !== 'ArrowDown' || key !== 'ArrowUp')
//     navigateImageSlider(key === 'ArrowDown' ? 'next' : 'prev');
// });

imageSlider.addEventListener(
  'scroll',
  (event) => {
    debounce(handleImageSliderScroll(event));
  },
  { passive: true }
);
function handleImageSliderScroll(event) {
  // console.log('scrolling. event: ', event);
  if (userScrolled) {
    // console.info('user has scrolled. canceling autoplay');
    // user is interacting. turn off autoplay
    clearImageSliderAutoPlay();
  }
}

export function initImageSliderAutoPlay() {
  // clear autoplay to start
  clearImageSliderAutoPlay();

  // (re)set userScrolled to false
  userScrolled = false;
  // console.log('in initImageSliderAutoPlay');
  imageSliderAutoplayInterval = setInterval(() => {
    // console.log('interval firing');
    navigateImageSlider('next');
  }, 5500);
}

function clearImageSliderAutoPlay() {
  // console.log('in clearImageSliderAutoPlay');
  clearInterval(imageSliderAutoplayInterval);
}

initImageSliderAutoPlay();

const wheelListenerOptions = [
  'mousewheel',
  (event) => debounce(handleImageSliderMouseWheel(event)),
  { passive: true },
];
function handleImageSliderMouseWheel(event) {
  console.log(
    'mousewheel! this listener will be removed now. current event:',
    event
  );
  console.log('user initiated a wheel scroll. autoplay will be cancelled.');
  userScrolled = true;
  imageSlider.removeEventListener(...wheelListenerOptions);
}
imageSlider.addEventListener(...wheelListenerOptions);

// Touch Swipe detection, for cancelling autoplay
// ---------------------------------------
// modified from comments found on https://gist.github.com/SleepWalker/da5636b1abcbaff48c4d
// ---------------------------------------
let touchstartX = 0;
let touchstartY = 0;
let touchendX = 0;
let touchendY = 0;

imageSlider.addEventListener('touchstart', handleTouchStart, { passive: true });

function handleTouchStart(event) {
  touchstartX = event.changedTouches[0].screenX;
  touchstartY = event.changedTouches[0].screenY;
}

imageSlider.addEventListener('touchend', handleTouchEnd, false);

function handleTouchEnd(event) {
  touchendX = event.changedTouches[0].screenX;
  touchendY = event.changedTouches[0].screenY;

  const diffX = touchendX - touchstartX;
  const diffY = touchendY - touchstartY;
  const ratioX = Math.abs(diffX / diffY);
  const ratioY = Math.abs(diffY / diffX);

  const absDiff = Math.abs(ratioX > ratioY ? diffX : diffY);
  // Ignore small movements.
  if (absDiff < 30) {
    // console.info('touch distance too small to register as a swipe');
    return;
  }

  // horizontal swipe
  if (ratioX > ratioY) {
    // left or right specifically don't matter
    // if (diffX >= 0) {
    //   console.log('right swipe');
    // } else {
    //   console.log('left swipe');
    // }
    console.log('horizontal swipe');
    console.log(
      'user initiated a scroll via a touch swipe. autoplay will be cancelled.'
    );
    userScrolled = true;
    // now that a (horizontal) swipe has been detected, remove listeners
    imageSlider.removeEventListener('touchstart', handleTouchStart, false);
    imageSlider.removeEventListener('touchend', handleTouchEnd, false);
  }
  // ignore vertical swipes
  // else {
  //   if (diffY >= 0) {
  //     console.log('down swipe');
  //   } else {
  //     console.log('up swipe');
  //   }
  // }
}

// Intersection Observer for telling slide "dots" which one is active
let imageSliderObserverOptions = {
  root: imageSlider,
  // rootMargin: '0px',
  threshold: 0.5,
};
const imageSliderInView = (target) => {
  const interSecObs = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const currentElementId = entry.target.id;
      const affiliatedDot = document.querySelector(
        `.image-slider-jump-dots [href="#${currentElementId}"]`
      );
      affiliatedDot.classList.toggle(
        'my-slide-is-active',
        entry.isIntersecting
      );
    });
  }, imageSliderObserverOptions);
  interSecObs.observe(target);
};
imageSliderSlides.forEach(imageSliderInView);
